import { useCallback } from 'react'
import { getMe, login as apiLogin } from '../api/auth'
import { useAuthStore } from '../store/authStore'

export function useAuth() {
  const { token, username, role, setAuth, clearAuth, isAdmin } = useAuthStore()

  const login = useCallback(
    async (username: string, password: string) => {
      const { access_token } = await apiLogin(username, password)
      const me = await getMe(access_token)
      setAuth(access_token, me.username, me.role)
    },
    [setAuth],
  )

  const logout = useCallback(() => clearAuth(), [clearAuth])

  return {
    token,
    username,
    role,
    isAuthenticated: !!token,
    isAdmin: isAdmin(),
    login,
    logout,
  }
}
